"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = require("@angular/common/http");
var rxjs_1 = require("rxjs");
var _1 = require(".");
var operators_1 = require("rxjs/operators");
var OptionsService = /** @class */ (function () {
    function OptionsService(http, skillService) {
        this.http = http;
        this.skillService = skillService;
        this._chatContext$ = new rxjs_1.Subject();
        this.options$ = rxjs_1.combineLatest(this._chatContext$, this.skillService.getDefaultSkillAddress()).pipe(operators_1.map(function (_a) {
            var chatContext = _a[0], defaultSkillAddress = _a[1];
            var options = __assign({ SessionId: chatContext.sessionId, Location: chatContext.location.href, DefaultSkillId: '', DefaultSkillAddressName: chatContext.chatRuleData.TargetSkill || defaultSkillAddress }, chatContext.chatRuleData.Proactive);
            return options;
        }));
    }
    OptionsService.prototype.getProactiveFormDetails = function (lang, formTag) {
        return this.http.get("/api/ChatAdminSettings/GetPrechatForm/" + lang + "/" + formTag);
    };
    OptionsService.prototype.updateChatContext = function (context) {
        this._chatContext$.next(context);
    };
    return OptionsService;
}());
exports.OptionsService = OptionsService;
